import { FC, ReactNode } from 'react';

import classNames from 'classnames';
import getClassNames from '../../utils/getClassNames';
import style from './Navigation.module.scss';
import IconDS22, { IconIds } from '../IconDS22';
import UniversalLink from '../UniversalLink';

type NavItemProps = {
  children: React.ReactNode;
  classNameModifier?: string;
  icon?: IconIds;
  indicator?: ReactNode;
  openInNewTab?: boolean;
  to: string;
  title?: string;
  variant?: 'topNav' | 'subNav';
  disabled?: boolean;
};

const NavItem: FC<NavItemProps> = ({
  children,
  classNameModifier = '',
  icon,
  indicator,
  openInNewTab = false,
  to,
  title = '',
  variant,
  disabled = false,
}) => (
  <UniversalLink
    href={to}
    className={getClassNames(style, 'link', classNames(classNameModifier, 'anonymous'))}
    title={title}
    openInNewTab={openInNewTab}
    aria-disabled={disabled ? 'true' : undefined}
    tabIndex={disabled ? -1 : undefined}
  >
    {icon && (
      <IconDS22
        id={icon}
        size={variant === 'subNav' ? 'm' : 'l'}
      />
    )}
    <span className={getClassNames(style, 'children', classNameModifier)}>{children}</span>
    {indicator}
  </UniversalLink>
);

export default NavItem;
